import request from '@/utils/request.js'

export function attrList() {
  return request({
    url: '/attr/list',
    method: 'get',
  })
}
